const currentYear = new Date().getFullYear();
export const previousYear = currentYear - 1;
